import { useState,  forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    DialogTitle,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { Save } from '@mui/icons-material';

import { makeid } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { common_data_entry } from '../definitions/property';
import { MyInputAdvance } from '../components/MyInput';


const newproperty = {
    name: '',
    birth: 0,
}




export const PropertyDialog = forwardRef(({  addFn, editFn }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newproperty })
    const [isEdited, setIsEdited] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)





    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newproperty, property_code: makeid(8, true) })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newproperty, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            addFn(curElement)
        } else {
            editFn(curElement, index)
        }
        setOpen(false)
    }





    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked
        }
        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        } else {
            setCurElement(el => {
                let _el = { ...el }
                delete _el[name]
                return { ..._el }
            })
            setIsEdited(true)
        }
    }










    const checkConditional = (param) => {
        if (param.conditional) {
            if (curElement[param.conditional.param] && curElement[param.conditional.param] >= param.conditional.min_value) {
                return true
            }
            return false
        } else {
            return true
        }
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    Dati Azienda:  <b>{curElement.name}</b>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        {common_data_entry.map((p, pk) => {
                            if (checkConditional(p))
                                return (
                                    <MyInputAdvance
                                        key={pk}
                                        id={p.id}
                                        label={p.label}
                                        type={p.type}
                                        min_value={p.min_value}
                                        value={curElement ? curElement[p.id] : ''}
                                        onChange={(ev) => onChangeHandler(ev.target)}
                                    />
                                )
                        })}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary"  loadingPosition="start">Salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})


